import moment from "moment";
import React from "react";
import ExpectationsList from "./Expectations/ExpectationsList";
import BootstrapTable from "react-bootstrap-table-next";
import { Row, Col } from "reactstrap";
import LottieLoader from '../../LottieLoader';
import lottieEmptyFile from '../../../files/animation/empty_new.json';
import BP from "files/devices/eocene_image_blood_monitor_transparent.png";
import GLUCOSE from "files/devices/eocene_image_glucose_analyzertransparent.png";
import TEMPERATURE from "files/devices/eocene_image_infrared_ear_and_body_termotransparent.png";
import WEIGH from "files/devices/eocene_image_weight_scaletransparent.png";
import PULSE from "files/devices/eocene_pulseoxygenetransparent.png";
import BODYTRACEBP from "files/devices/body_trace_blood_pressure.png";
import BODYTRACEWEIGHT from "files/devices/body_trace_weight_scale.png";
import NO_IMAGE_DEVICE from "../../../files/ic_no_client_images.png";
import _ from "lodash";
import PatientProfileHeaderPrint from "../../Reusable/PatintProfileHeaderPrint";

export const CarePlanPrint = ({ latestReadingUser, ccmTotalDuration, rpmTotalDuration, profile, latestSubmission, loadingCarePlan, ongoingRequestCarePlan, patientConditions, devices, sortedArrayViewExpectations, userId, rpmCarePlanList }) => {
    function fullname(cell, row) {
        if (!row.device) {
            return <div>Wrong Device</div>;
        }
        if (row.device.brand.indexOf("Body Trace Blood") > -1)
            return (
                <div className="text-center">
                    <img height="200px" src={BODYTRACEBP} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.brand.indexOf("Body Trace Weight") > -1)
            return (
                <div className="text-center">
                    <img height="200px" src={BODYTRACEWEIGHT} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.name.indexOf("Blood") > -1)
            return (
                <div className="text-center">
                    <img height="200px" src={BP} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.name.indexOf("Glucose") > -1)
            return (
                <div className="text-center">
                    <img src={GLUCOSE} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.name.indexOf("Thermometer") > -1)
            return (
                <div className="text-center">
                    <img src={TEMPERATURE} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.name.indexOf("Weigh") > -1)
            return (
                <div className="text-center">
                    <img src={WEIGH} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.name.indexOf("Pulse") > -1)
            return (
                <div className="text-center">
                    <img src={PULSE} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        return (
            <div className="text-center">
                <img src={NO_IMAGE_DEVICE} className="rounded-circle img-fluid reading-icon-summary" />
            </div>
        );
    }
    function toCapitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return (
        <div>
        <div className="print-page-title">Required Documentation for CPT Codes 99453, 99454, 99457, 99458</div>
            <PatientProfileHeaderPrint
            profile={profile}
            latestReadingUser={latestReadingUser}
            ccmTotalDuration = {ccmTotalDuration}
            rpmTotalDuration = {rpmTotalDuration}>
            </PatientProfileHeaderPrint>
            {/* RPM CarePlan Form */}
            {(profile.enrolledPrograms == "CCM&RPM" || profile.enrolledPrograms == "RPM") && (
                <div>
                    <div className="care-plan-header-background " style={{ marginTop: 25 }}>
                        <Row>
                            <Col sm="12" className="center-label remove-table-padding">
                                <h3 className="text-center title-device" style={{ marginLeft: 25 }}>
                                    <i class="mdi mdi-medical-bag"></i> RPM Care Plan Details
                                </h3>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <BootstrapTable
                            wrapperClasses="table-responsive"
                            keyField="_id"
                            bordered={true}
                            hover={true}
                            condensed={true}
                            noDataIndication={() => (
                                <div>
                                    <LottieLoader
                                        loadLoop={false}
                                        autoplayLoop={true}
                                        source={lottieEmptyFile}
                                        Lheight={150}
                                        Lwidth={150}
                                        titleSmall={"Sorry! No RPM care plan found :("}
                                        subTitleSmall={"We can't find any RPM care plan submission."}
                                    />
                                </div>
                            )}
                            data={rpmCarePlanList ? rpmCarePlanList : []}
                            columns={[
                                {
                                    dataField: "description",
                                    text: "Medical Director / Supervisor",
                                    formatter: (cell, row) => (
                                        <div className="text-left">{row.medicalDirectorName || "Dr. Daniel Beirne"}</div>
                                    ),
                                    headerStyle: (colum, colIndex) => {
                                        return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                                    },
                                },
                                {
                                    dataField: "description",
                                    text: "Created By",
                                    formatter: () => {
                                        const mainCareProvider = profile && profile.mainCareProvider;
                                        if (!mainCareProvider || !mainCareProvider.fname) {
                                            return <div className="text-left"> - </div>;
                                        }
                                        return (
                                            <div className="text-left">{mainCareProvider.fname}{" "} {mainCareProvider.lname}</div>
                                        );
                                    },
                                    headerStyle: (colum, colIndex) => {
                                        return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                                    },
                                },
                                {
                                    dataField: "carePlanCreatedDate",
                                    text: "Created Date",
                                    formatter: (cell, row) => {
                                        const d = row.rpmOrderNoteDate || row.patientConsent?.rpmVerbalNoteDate || row.carePlanCreatedDate || row.createdAt;
                                        if (d) {
                                            return moment(d).tz(moment.tz.guess()).format("MMMM DD, YYYY");
                                        } else {
                                            return "NONE";
                                        }
                                    },
                                    headerStyle: (colum, colIndex) => {
                                        return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                                    },
                                },
                                {
                                    dataField: "description",
                                    text: "Last Modify Date",
                                    formatter: (cell, row) => {
                                        // Shows the same date as Created Date.
                                        const d = row.rpmOrderNoteDate || row.patientConsent?.rpmVerbalNoteDate || row.carePlanCreatedDate || row.createdAt;
                                        if (d) {
                                            return moment(d).tz(moment.tz.guess()).format("MMMM DD, YYYY");
                                        } else {
                                            return "NONE";
                                        }
                                    },
                                    headerStyle: (colum, colIndex) => {
                                        return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                                    },
                                },
                            ]}
                        />
                    </div>
                </div>
            )}
            {/* CCM CarePlan Form */}
            {(profile.enrolledPrograms == "CCM&RPM" || profile.enrolledPrograms == "CCM") && (
                <div>
                    <div className="care-plan-header-background ">
                        <Row>
                            <Col sm="12" className="center-label remove-table-padding">
                                <h3 className="text-center title-device" style={{ marginLeft: 25 }}>
                                    <i class="mdi mdi-medical-bag"></i> CCM Care Plan Details
                                </h3>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <BootstrapTable
                            wrapperClasses="table-responsive"
                            keyField="_id"
                            bordered={true}
                            hover={true}
                            condensed={true}
                            noDataIndication={() => (
                                <div>
                                    <LottieLoader
                                        loadLoop={false}
                                        autoplayLoop={true}
                                        source={lottieEmptyFile}
                                        Lheight={150}
                                        Lwidth={150}
                                        titleSmall={"Sorry! No submission found :("}
                                        subTitleSmall={"We can't find any submission."}
                                    />
                                </div>
                            )}
                            data={latestSubmission ? latestSubmission : []}
                            columns={[
                                {
                                    dataField: "description",
                                    text: "Created By",
                                    formatter: (cell, row) => {
                                        if (!row.createdBy) {
                                            return <div className="text-left"> - </div>;
                                        }
                                        return (
                                            <div className="text-left">{row.createdBy.fname}{" "} {row.createdBy.lname}</div>
                                        );
                                    },
                                    headerStyle: (colum, colIndex) => {
                                        return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                                    },
                                },
                                {
                                    dataField: "description",
                                    text: "Modify By",
                                    formatter: (cell, row) => {
                                        if (!row.modifyBy) {
                                            return <div className="text-left"> Initial Form </div>;
                                        }
                                        return (
                                            <div className="text-left">{row.modifyBy.fname}{" "} {row.modifyBy.lname}</div>
                                        );
                                    },
                                    headerStyle: (colum, colIndex) => {
                                        return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                                    },
                                },
                                {
                                    dataField: "createdAt",
                                    text: "Created Date",
                                    formatter: (cell, row) => {
                                        if (row.createdDate) {
                                            return moment(row.createdDate).tz(moment.tz.guess()).format("MMMM DD, YYYY HH:mm:ss");
                                        } else {
                                            return "NONE";
                                        }
                                    },
                                    headerStyle: (colum, colIndex) => {
                                        return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                                    },
                                },
                                {
                                    dataField: "description",
                                    text: "Last Modify Date",
                                    formatter: (cell, row) => {
                                        if (row.modifyDate) {
                                            return moment(row.modifyDate).tz(moment.tz.guess()).format("MMMM DD, YYYY HH:mm:ss");
                                        } else {
                                            return "NONE";
                                        }
                                    },
                                    headerStyle: (colum, colIndex) => {
                                        return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                                    },
                                },
                            ]}
                        />
                    </div>
                </div>
            )}            
            {!loadingCarePlan && !ongoingRequestCarePlan && (
                <div>
                    <div className="care-plan-header-background ">
                        <Row>
                            <Col sm="12" className="center-label remove-table-padding">
                                <h3 className="text-center title-device" style={{ marginLeft: 25 }}>
                                    <i class="mdi mdi-medical-bag"></i> Prescribed Conditions
                                </h3>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <div className="scrollbar-table-cls">
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                keyField="_id"
                                bordered={true}
                                hover={true}
                                condensed={true}
                                noDataIndication={() => (
                                    <div>
                                        <LottieLoader
                                            loadLoop={false}
                                            autoplayLoop={true}
                                            source={lottieEmptyFile}
                                            Lheight={200}
                                            Lwidth={200}
                                            titleSmall={"Sorry! No prescribed conditions found :("}
                                            subTitleSmall={"We can't find any prescribed conditions."}
                                        />
                                    </div>
                                )}
                                data={patientConditions ? patientConditions : []}
                                columns={[
                                    {
                                        dataField: "condition",
                                        text: "Name",
                                        headerStyle: (colum, colIndex) => {
                                            return { padding: "13px", fontSize: "16px", color: "#070707", width: '18%' };
                                        },
                                        formatter: (cell, row) => {
                                            if (!row.careprovider) {
                                                return <div>{row.condition} ()</div>;
                                            }
                                            return (
                                                <div>
                                                    {row.condition}
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        dataField: "description",
                                        text: "Description",
                                        headerStyle: (column, colIndex) => {
                                            return { padding: "13px", fontSize: "16px", color: "#070707" };
                                        },
                                    },

                                    {
                                        dataField: "description",
                                        text: "Created By",
                                        formatter: (cell, row) => {
                                            if (!row.careprovider) {
                                                return <div className="text-center"> - </div>;
                                            }
                                            return (
                                                <div>{row.careprovider.fname}{" "} {row.careprovider.lname}</div>
                                            );
                                        },
                                        headerStyle: (colum, colIndex) => {
                                            return { padding: "13px", fontSize: "16px", color: "#070707", width: '12%' };
                                        },
                                    }, {
                                        dataField: "updatedAt",
                                        text: "Last Updated",
                                        formatter: (cell, row) => {
                                            if (row.updatedAt) {
                                                return moment(row.updatedAt).tz(moment.tz.guess()).format("MMMM DD, YYYY");
                                            } else {
                                                return "NONE";
                                            }
                                        },
                                        headerStyle: (colum, colIndex) => {
                                            return { padding: "16px", fontSize: "13px", color: "#070707", width: '13%' };
                                        },
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </div>
            )}
            {/* Prescribed Devices and Prescribed Testing Frequency */}
            {!loadingCarePlan && !ongoingRequestCarePlan && devices && (
                <div>
                    <div className="care-plan-header-background" style={{ marginTop: 25 }}>
                        <Row>
                            <Col sm="12" className="center-label remove-table-padding">
                                <h3 className="text-center title-device" style={{ marginLeft: 25 }}>
                                    <i class="mdi mdi-mailbox"></i> Prescribed Devices and Prescribed Testing Frequency
                                </h3>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <div className="scrollbar-table-cls">
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                keyField="id"
                                bordered={true}
                                hover={true}
                                condensed={true}
                                data={devices ? devices : []}
                                noDataIndication={() => (
                                    <div>
                                        <LottieLoader
                                            loadLoop={false}
                                            autoplayLoop={true}
                                            source={lottieEmptyFile}
                                            Lheight={200}
                                            Lwidth={200}
                                            titleSmall={"Sorry! No device found :("}
                                            subTitleSmall={"We can't find any devices."}
                                        />
                                    </div>
                                )}
                                columns={[
                                    {
                                        dataField: "_id",
                                        text: "",
                                        formatter: fullname,
                                        headerStyle: (colum, colIndex) => {
                                            return {
                                                width: "7%",
                                                textAlign: "center",
                                                padding: "13px", fontSize: "16px", color: "#070707"
                                            };
                                        }
                                    },
                                    {
                                        dataField: "device.brand",
                                        text: "Device Brand",
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "15%", padding: "13px", fontSize: "16px", color: "#070707" };
                                        },
                                    },
                                    {
                                        dataField: "device.deviceType.description",
                                        text: "Device Type",
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "15%", padding: "13px", fontSize: "16px", color: "#070707" };
                                        },
                                    },
                                    {
                                        dataField: "device.brandModel",
                                        text: "Device Model",
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "15%", padding: "13px", fontSize: "16px", color: "#070707" };
                                        },
                                    },
                                    {
                                        dataField: "serial",
                                        text: "Serial Number",
                                        formatter: (cell, row) => {
                                            return row.serial ? row.serial : "-";
                                        },
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "15%", padding: "13px", fontSize: "16px", color: "#070707" };
                                        },
                                    },

                                    {
                                        dataField: "performTest",
                                        text: "Perform Test",
                                        formatter: (cell, row) => {
                                            if(row.performTest){
                                             return <div>{row.performTest}</div>;
                                            }else{
                                             return <div className="text-center">-</div>;
                                            }
                                        },
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "13%", padding: "13px", fontSize: "16px", color: "#070707" };
                                        },
                                    },
                                    {
                                        dataField: "testingFrequency",
                                        text: "Testing Frequency",
                                        formatter: (cell, row) => {
                                            if(row.testingFrequency){
                                              return <div>{row.testingFrequency}</div>;
                                            }else{
                                              return <div className="text-center">-</div>;
                                            }
                                        },
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", padding: "13px", fontSize: "16px", color: "#070707" };
                                        },
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </div>
            )}
            {/* Prescribed Expectations */}
            {!loadingCarePlan && !ongoingRequestCarePlan && (
                    <div>
                        <div className="care-plan-header-background" style={{ marginTop: 25 }}>
                            <Row>
                                <Col sm="12" className="center-label remove-table-padding">
                                    <h3
                                        className="text-center title-device"
                                        style={{ marginLeft: 25 }}
                                    >
                                        <i class="mdi mdi-marker-check"></i> Prescribed Expectations
                                    </h3>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <div className="scrollbar-table-cls">
                                <BootstrapTable
                                    wrapperClasses="table-responsive"
                                    keyField="id"
                                    bordered={true}
                                    hover={true}
                                    condensed={true}
                                    noDataIndication={() => (
                                        <div>
                                            <LottieLoader
                                                loadLoop={false}
                                                autoplayLoop={true}
                                                source={lottieEmptyFile}
                                                Lheight={200}
                                                Lwidth={200}
                                                titleSmall={"Sorry! No prescribed expectations found :("}
                                                subTitleSmall={"We can't find any prescribed expectations."}
                                            />
                                        </div>
                                    )}
                                    data={sortedArrayViewExpectations ? sortedArrayViewExpectations : []}
                                    headerClasses="header-class-care-plan-table"
                                    columns={[
                                        {
                                            dataField: "name",
                                            text: "Name",
                                            formatter: (cell, row) => {
                                                return <div>{row.name}</div>;
                                            },
                                            headerStyle: (colum, colIndex) => {
                                                return {
                                                    width : '19%',
                                                    padding: "13px",
                                                    fontSize: "16px",
                                                    color: "#070707",
                                                };
                                            },
                                        },
                                        {
                                            dataField: "createdBy.lname",
                                            text: "Created By",
                                            headerStyle: (colum, colIndex) => {
                                                return {
                                                    width : '15%',
                                                    textAlign: "left",
                                                    padding: "13px",
                                                    fontSize: "16px",
                                                    color: "#070707",
                                                };
                                            },
                                            formatter: (cell, row) => {
                                                if (!row.createdBy) {
                                                    return <div className="text-left">-</div>;
                                                }
                                                return (
                                                    <div className="text-left">
                                                        {toCapitalize(row.createdBy.lname)}{" "}
                                                        {toCapitalize(row.createdBy.fname)}
                                                    </div>
                                                );
                                            },
                                        },
                                        {
                                            dataField: "ruleType",
                                            text: "Expectation Type",
                                            headerStyle: (colum, colIndex) => {
                                                return {
                                                    textAlign: "left",
                                                    padding: "13px",
                                                    fontSize: "16px",
                                                    color: "#070707",
                                                    width : '14%',
                                                };
                                            },
                                            formatter: (cell, row) => {
                                                return <div>{row.ruleType}</div>;
                                            },
                                        },
                                        {
                                            dataField: "readingType.description",
                                            text: "Reading Type",
                                            formatter: (cell, row) => {
                                                if (row.readingSubType) {
                                                    return (
                                                        <div className="text-left">
                                                            {row.readingType.description}
                                                        </div>
                                                    );
                                                } else {
                                                    return <div className="text-left">-</div>;
                                                }
                                            },
                                            headerStyle: (colum, colIndex) => {
                                                return {
                                                    padding: "13px",
                                                    fontSize: "16px",
                                                    color: "#070707",
                                                     width : '15%',
                                                };
                                            },
                                        },
                                        {
                                            dataField: "readingSubType",
                                            text: "Reading SubType",
                                            formatter: (cell, row) => {
                                                if (row.readingSubType) {
                                                    return (
                                                        <div className="text-left">{row.readingSubType}</div>
                                                    );
                                                } else {
                                                    return <div className="text-left">-</div>;
                                                }
                                            },
                                            headerStyle: (colum, colIndex) => {
                                                return {
                                                    padding: "13px",
                                                    fontSize: "16px",
                                                    color: "#070707",
                                                    width : '12%',
                                                };
                                            },
                                        },
                                        {
                                            dataField: "condition",
                                            text: "Expectation",
                                            formatter: (cell, row) => {
                                                switch (row.ruleType) {
                                                    case "Vitals":
                                                        if (row.condition == "<=") {
                                                            return "Less than or equal to";
                                                        } else if (row.condition == ">=") {
                                                            return "Greater than or equal to";
                                                        } else if (row.condition == "between") {
                                                            return "Between";
                                                        } else if (
                                                            row.name.includes("Daily") ||
                                                            row.name.includes("1 X")
                                                        ) {
                                                            return "1 x per day";
                                                        } else if (row.name.includes("2 X")) {
                                                            return "2 x per day";
                                                        } else {
                                                            return <div className="text-center">-</div>;
                                                        }
                                                        break;
                                                    case "Adherence":
                                                        return row.repeatPerDay && row.repeatPerDay == 1
                                                            ? "Daily"
                                                            : row.repeatPerDay + " Days";
                                                    case "Trending Violation":
                                                        return (
                                                            row.numberOfTimes +
                                                            " Times With In " +
                                                            toCapitalize(row.repeatPer)
                                                        );
                                                    case "Weight":
                                                        return row.gainLossPerDay + " Per Day";
                                                    case "Reminder":
                                                    case "Time Adherence":
                                                        if (row.time && _.size(row.time) > 0) {
                                                            let text = [];
                                                            _.map(row.time, (model, index) => {
                                                                if (_.size(row.time) - 1 == index) {
                                                                    text.push(<span>{model}</span>);
                                                                } else {
                                                                    text.push(<span>{model}, </span>);
                                                                }
                                                            });
                                                            return <div> {text}</div>;
                                                        } else {
                                                            return <div className="text-center">-</div>;
                                                        }
                                                    default:
                                                        if (row.condition == "<=") {
                                                            return "Less than or equal to";
                                                        } else if (row.condition == ">=") {
                                                            return "Greater than or equal to";
                                                        } else if (
                                                            row.name.includes("Daily") ||
                                                            row.name.includes("1 X")
                                                        ) {
                                                            return "1 x per day";
                                                        } else if (row.name.includes("2 X")) {
                                                            return "2 x per day";
                                                        }
                                                        return row.condition;
                                                }
                                            },
                                            headerStyle: (colum, colIndex) => {
                                                return {
                                                    padding: "13px",
                                                    fontSize: "16px",
                                                    color: "#070707",
                                                    width : '15%',
                                                };
                                            },
                                        },
                                        {
                                            dataField: "valueProperty",
                                            text: "Value",
                                            headerStyle: (colum, colIndex) => {
                                                return {
                                                    width: "10%",
                                                    padding: "13px",
                                                    fontSize: "16px",
                                                    color: "#070707",
                                                };
                                            },
                                            formatter: (cell, row) => {
                                                if (
                                                    row.valueProperty &&
                                                    row["valueProperty"] !== undefined &&
                                                    row.valueProperty.length > 0
                                                ) {
                                                    if (row.condition != "between") {
                                                        return (
                                                            <div>
                                                                {row.valueProperty[0].value}
                                                            </div>
                                                        );
                                                    } else if (row.condition == "between") {
                                                        return (
                                                            <div>
                                                                {row.valueProperty[0].minValue} and{" "}
                                                                {row.valueProperty[0].maxValue}
                                                            </div>
                                                        );
                                                    } else {
                                                        return <div className="text-center">-</div>;
                                                    }
                                                } else {
                                                    return <div className="text-center">-</div>;
                                                }
                                            },
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
            )}
        </div>
    )
}